import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Upholstery = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my upholstery business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps upholstery businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for upholstery businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most upholstery businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my upholstery business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like upholstery. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Upholstery - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Upholstery CRM", url: "/industries/upholstery" }
  ];

  const industryData = {
    name: 'Upholstery & Furniture Repair',
    title: 'Stop Losing Estimate Leads & Build Restoration Project Pipeline',
    subtitle: 'Automate estimate follow-ups, showcase your work, and book projects weeks in advance',
    icon: '🛋️',
    challenges: [
      'Estimates go cold while working on jobs',
      'Hard to showcase quality of work',
      'Complex projects take months to book',
      'Difficult to track fabric selections',
      'One-time customers never return'
    ],
    solutions: [
      'Automated estimate follow-up',
      'Digital portfolio showcasing',
      'Project pipeline management',
      'Fabric selection tracking',
      'Repeat customer nurture campaigns'
    ],
    features: [
      'Customer CRM with project history',
      'Estimate tracking and follow-up',
      'Before/after photo galleries',
      'Fabric sample management',
      'Project scheduling',
      'Pickup and delivery tracking',
      'Restoration documentation',
      'Review automation'
    ],
    results: [
      '55% more estimates convert',
      'Book 6-8 weeks in advance',
      '40% return for additional work',
      '5.4K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Upholstery UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for upholstery businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for upholstery UK, upholstery business software, upholstery customer management, upholstery lead generation UK"
        url="/industries/upholstery"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Upholstery;